



import { provideToast } from "vue-toastification/composition"
import "vue-toastification/dist/index.css"
import {defineComponent} from "@vue/composition-api"

export default defineComponent({
  setup() {
    provideToast({ timeout: 3000 })
  }
})
